import React from 'react';
import classNames from "classnames";

import Framework from "@beardeddevops/react.framework"
import {Objects} from "components";
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import UserRoles from "../../../../../constants/UserRoles";

const breadcrumbsStatic = [{
	name: 'Refund',
	url: '/refunds',
	icon: 'phone',
}];

export default class Refund extends Framework.Components.View {

	constructor(props) {
		super(props);

	}
	render() {
		let {match, history, baseUrl, roles} = this.props;

		return (
			<div className="container-fluid">
				<Framework.Components.PageBar breadcrumbs={breadcrumbsStatic} history={history}/>
				{/*<Tabs value={this.state.tab} onChange={this.handleTabChange} component={'div'}>*/}
				{/*	<Tab label="Phone" value="details"/>*/}
				{/*	/!*<Tab label ="Change Log" value="changelog"/>*!/*/}
				{/*</Tabs>*/}
				{/*<div className={classNames({'hidden': this.state.tab !== 'details'})}>*/}
					<Objects.Refund
						key={this.state.key}
						id={match.params.id}
						history={this.props.history}
						reloadShell={this.props.reloadShell}
						reloadPage={this.refreshPage}
						reloadSelf={this.state.refresh}
						updateName={this.updateName}
						baseUrl={baseUrl}
						goBack={true}
						noDelete={false}
					/>
				{/*</div>*/}



			</div>
		)
	}
};
